import { defineStore } from 'pinia';
import { useApi } from '@/lib/api';
import { useGlobalStore } from '@/store/global-store-base';

export const useTreatments = defineStore('treatments', () => {
  const api = useApi();
  const globalStoreBase = useGlobalStore({
    load: api.treatment_GetTreatments,
    dto: 'TreatmentDto',
    create: api.treatment_CreateTreatment,
    update: api.treatment_UpdateTreatment,
    delete: api.treatment_DeleteTreatment,
    signalR: 'TreatmentUpdate',
  });

  return {
    ...globalStoreBase,
  };
});
